import { gql } from 'graphql-request';

import { FRAGMENT_PROPERTY_LOCATION } from './fragments/PropertyStateLocation.graphql';
import { FRAGMENT_MSA_PREVIEW } from './fragments';

export const QUERY_PROPERTY_LOCATION = gql`
  ${FRAGMENT_PROPERTY_LOCATION}
  ${FRAGMENT_MSA_PREVIEW}
  query PropertyLocation($cerberusInput: CerberusInput!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    # HC CAPABILITY: aexp-product-access
    lookup(id: $cerberusInput) {
      propertyDetails {
        hcAddressId
        location {
          ...PropertyLocation
        }
        msaDetails {
          ...MsaPreview
        }
      }
    }
  }
`;
